var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.12 9V8.4L3.348 0.396H4.32L7.536 8.4V9H0.12ZM1.356 8.028H6.288L4.284 2.796C4.26 2.732 4.216 2.616 4.152 2.448C4.088 2.28 4.024 2.108 3.96 1.932C3.904 1.748 3.86 1.608 3.828 1.512C3.788 1.672 3.74 1.836 3.684 2.004C3.636 2.164 3.584 2.312 3.528 2.448C3.48 2.584 3.44 2.7 3.408 2.796L1.356 8.028Z",
    fill: "white",
    fillOpacity: 0.64
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelta);
export default __webpack_public_path__ + "static/media/delta.e1c6e53f5d6860879992dcdbb072a4c2.svg";
export { ForwardRef as ReactComponent };